export default function Loader({ size = '2' }) {
  return (
    <div className="text-center py-4">
      <i className={`fa-solid fa-${size}x fa-spinner fa-pulse text-primary`} />
    </div>
  )
}